import data from "../../.sourceflow/offices.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getOffices = (locale = "en") => {
  return new BaseCollection(data, locale).getItems();
};
